import { FormlyFieldConfig } from "@ngx-formly/core";

export function GetField(key: string, fields: FormlyFieldConfig[]): FormlyFieldConfig {
    for (let i = 0, len = fields.length; i < len; i++) {
        const f = fields[i];
        if (f.key === key) {
            return f;
        }

        if (f.fieldGroup && !f.key) {
            const cf = GetField(key, f.fieldGroup);
            if (cf) {
                return cf;
            }
        }
    }
}

/**
 * Same walk as GetField, but returns every field carrying the key instead of stopping at the
 * first. Needed where a form declares one key more than once and shows a different copy per
 * template — the category form has a standard `taxRateMasterId` and an Entertainment one, so
 * GetField only ever reaches the standard field.
 */
export function GetAllFields(key: string, fields: FormlyFieldConfig[]): FormlyFieldConfig[] {
    const matchedFields: FormlyFieldConfig[] = [];
    for (let i = 0, len = fields.length; i < len; i++) {
        const f = fields[i];
        if (f.key === key) {
            matchedFields.push(f);
        }

        if (f.fieldGroup && !f.key) {
            matchedFields.push(...GetAllFields(key, f.fieldGroup));
        }
    }
    return matchedFields;
}
